// extracted by mini-css-extract-plugin
export default {"wrapper":"H7-z","play":"I7-z"};